import { CircularProgress } from "@material-ui/core";
import React from "react";

const LoadingSplashScreen = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "grid",
        placeItems: "center",
        backgroundColor: "rgba(255,255,255,0.7)",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default LoadingSplashScreen;
